/**
 * @description Method to check if an item is an object. Date and Function are considered
 * an object, so if you need to exclude those, please update the method accordingly.
 * @param item - The item that needs to be checked
 * @return {Boolean} Whether or not @item is an object
 */

var isObject = item => item === Object(item) && !Array.isArray(item);

export { isObject as i };
//# sourceMappingURL=isObject-CgRrra7h.js.map
